import styled from 'styled-components';
import { Link } from 'react-router';
import { breakpoints } from 'styles';

export const SelectButtonGrid = styled.div`
  display: flex;
  gap: 16px;
  margin: 8px 0 32px;
`;

export const FormText = styled.p`
  font-size: 16px;
  line-height: 24px;

  @media (max-width: ${breakpoints.s}px) {
    padding: 0;
  }

  > a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const MessageLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  padding: 0 4px;
  text-decoration: underline;
  font-weight: bold;
`;

export const AcceptConsent = styled.label`
  display: flex;
  gap: 24px;
  cursor: pointer;

  @media (max-width: ${breakpoints.s}px) {
    gap: 16px;
  }
`;

export const CheckBoxContainer = styled.div`
  padding-top: 16px;
`;

export const CheckBoxText = styled.p`
  font-size: 16px;
  line-height: 24px;
  padding: 0;
`;
